import {forOwn, set, cloneDeep, unset} from 'lodash';
import {STANDARD_DATE_TIME_FORMAT} from "Core/const/datetime";
import {getDateString} from "Core/helpers/datetime";
import {getString, removeEmptyObjectProps, resetObjectValues} from 'Core/helpers/data';
import {formatNumber} from 'Core/helpers/number';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data.
 * @return {Object}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	forOwn(result, (value, key) => {
		// Remove 'projectIds' from filter since this is a hardcoded filter
		if (key === 'projectIds') unset(result, key);
	});

	// Convert birthday related fields into a new field combining month and day values that can be used by the 
	// YearDaySelectInput input component used in the filter
	if (!!result) {
		if (
			result.hasOwnProperty('birthMonthFrom') && result.hasOwnProperty('birthDayFrom') &&
			!!result.birthMonthFrom && !!result.birthDayFrom
		) {
			set(
				result,
				'birthdayFrom',
				`${formatNumber(result.birthMonthFrom, '00')}-${formatNumber(result.birthDayFrom, '00')}`
			);
			unset(result, 'birthMonthFrom');
			unset(result, 'birthDayFrom');
		}
		if (
			result.hasOwnProperty('birthMonthTo') && result.hasOwnProperty('birthDayTo') &&
			!!result.birthMonthTo && !!result.birthDayTo
		) {
			set(
				result,
				'birthdayTo',
				`${formatNumber(result.birthMonthTo, '00')}-${formatNumber(result.birthDayTo, '00')}`
			);
			unset(result, 'birthMonthTo');
			unset(result, 'birthDayTo');
		}
	}

	return result;
}

/**
 * Get output data from input data
 * @param {Object} input - Input value.
 * @return {Object}
 */
export const output = input => {
	let result = cloneDeep(input);

	forOwn(result, (value, key) => {
		// Convert Date object to appropriate date string
		if (value instanceof Date) set(result, key, getDateString(value, STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S));

		// Convert birthday related fields into separate fields for month and day since that ios what APi expects
		if (key === 'birthdayFrom' || key === 'birthdayTo') {
			if (key === 'birthdayFrom') {
				const birthdayFromParsed = getString(value).split('-').filter(i => !!i).map(i => +i);
				if (birthdayFromParsed.length === 2) {
					set(result, 'birthMonthFrom', birthdayFromParsed[0]);
					set(result, 'birthDayFrom', birthdayFromParsed[1]);
				}
				unset(result, 'birthdayFrom');
			} else {
				const birthdayToParsed = getString(value).split('-').filter(i => !!i).map(i => +i);
				if (birthdayToParsed.length === 2) {
					set(result, 'birthMonthTo', birthdayToParsed[0]);
					set(result, 'birthDayTo', birthdayToParsed[1]);
				}
				unset(result, 'birthdayTo');
			}
		}
	});
	
	// Set proper empty values expected by the API
	result = removeEmptyObjectProps(resetObjectValues(result));

	return result;
}